import { render, staticRenderFns } from "./MedicoSolicitante.vue?vue&type=template&id=3bd09eb2&"
import script from "./MedicoSolicitante.vue?vue&type=script&lang=js&"
export * from "./MedicoSolicitante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports